import { createAppWrap } from '../../create_app_wrap';
import commonMixin from './mixin';
import modalMailTemplate from './_modal_mail_template';
import modalReturnExchange from './_modal_return_exchange';

const view = '[data-view="setup-mail"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * データ群
         */
        data() {
            return {
                // ご注文承諾 PC版
                accept_pc_data: {},
                // ご注文承諾 モバイル版
                accept_mb_data: {},
                // 出荷のご連絡 パソコン版
                shipping_pc_data: {},
                // 出荷のご連絡 パソコン版
                shipping_mb_data: {},
                shop_guides: {}
            };
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin
        ],
        /**
         * コンポーネント群
         */
        components: {
            'modal-mail-template': modalMailTemplate,
            'modal-return-exchange': modalReturnExchange,
        },
        mounted: function () {
            console.log('>>>> mail created.');
        },
        /**
         * 描画後に実行される処理
         */
        created: function () {
            // setup_data.shop_mail_templatesの配列番号はshop_mail_templates.noに合わせているので、
            // 0番には値無し
            this.accept_pc_data = this.setup_data.shop_mail_templates[1];
            this.accept_mb_data = this.setup_data.shop_mail_templates[2];
            this.shipping_pc_data = this.setup_data.shop_mail_templates[3];
            this.shipping_mb_data = this.setup_data.shop_mail_templates[4];
            this.shop_guides = this.setup_data.shop_guides;
        },
        /**
         * 監視プロパティ
         */
        watch: {
            // エラーメッセージの行番号をテンプレート名へ変換する
            messages: function (messages) {
                messages.map( (message) => {
                    const index = Number(message.message.replace(/^([0-9]{1,2})(.*)$/, '$1')) - 1;
                    if (index >= 0) {
                        const templName = this.setup_data.shop_mail_templates[index].ml_templ_name;
                        message.message = message.message.replace(/^[0-9]{1,2}/, '「' + templName + '」');
                    }
                    return message;
                });
            }
        },
        /**
         * 算出プロパティ
         */
        computed: {
        },
        /**
         * 各種メソッド
         */
        methods: {
            // メールテンプレートの編集内容確定
            decidedMailTemplate: function(args) {
                // setup_data.shop_mail_templatesの配列番号はshop_mail_templates.noに合わせているので、
                // 0番には値無し
                if (args.kind == 'accept_pc') {
                    this.merge(this.accept_pc_data, args.modal_data);
                    this.merge(this.setup_data.shop_mail_templates[1], args.modal_data);
                    return;
                }
                if (args.kind == 'accept_mb') {
                    this.merge(this.accept_mb_data, args.modal_data);
                    this.merge(this.setup_data.shop_mail_templates[2], args.modal_data);
                    return;
                }
                if (args.kind == 'shipping_pc') {
                    this.merge(this.shipping_pc_data, args.modal_data);
                    this.merge(this.setup_data.shop_mail_templates[3], args.modal_data);
                    return;
                }
                if (args.kind == 'shipping_mb') {
                    this.merge(this.shipping_mb_data, args.modal_data);
                    this.merge(this.setup_data.shop_mail_templates[4], args.modal_data);
                    return;
                }
            },
            // 返品・交換についての編集内容確定
            decidedReturnExchange: function(args) {
                this.merge(this.shop_guides, args.modal_data);
                this.merge(this.setup_data.shop_guides, args.modal_data);
                return;
            },

            /**
             * baseにnew_dataをマージ
             * baseに参照渡しで更新
            */
            merge: function(base, new_data) {
                base = Object.assign(base, new_data);
            }
        },
    });
};

if (document.querySelector(view)) {
    init();
}
